import { MdContentPaste } from 'react-icons/md';

import { Button } from '@/components/Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { mailMenuContentClassName, mailMenuItemClassName } from './VariableInsertMenu';

type TemplateInsertMenuProps = {
  templates: { id: number; name: string }[];
  emptyMessage: string | null;
  onSelect: (templateId: number) => void;
  disabled?: boolean;
};

export default function TemplateInsertMenu({
  templates,
  emptyMessage,
  onSelect,
  disabled,
}: TemplateInsertMenuProps) {
  return (
    <DropdownMenu modal={false}>
      <div className="group relative">
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            color="secondary"
            size="md"
            iconOnly
            aria-label="テンプレートを挿入"
            disabled={disabled}
            className="peer data-[state=open]:bg-gray_darken"
          >
            <MdContentPaste className="size-icon-xs" />
          </Button>
        </DropdownMenuTrigger>
        <span
          role="tooltip"
          className="pointer-events-none absolute bottom-full left-1/2 mb-xs hidden -translate-x-1/2 rounded-sm bg-main px-xs py-xxs text-body-xs whitespace-nowrap text-white group-hover:block peer-data-[state=open]:hidden!"
        >
          テンプレートを挿入
        </span>
      </div>
      <DropdownMenuContent
        side="top"
        align="end"
        sideOffset={7}
        className={`max-h-[240px]! w-[163px] min-w-0! overflow-y-auto ${mailMenuContentClassName}`}
      >
        {emptyMessage ? (
          <div className="px-sm py-xs text-body-sm text-sub">{emptyMessage}</div>
        ) : (
          templates.map((template) => (
            <DropdownMenuItem
              key={template.id}
              onClick={() => onSelect(template.id)}
              className={mailMenuItemClassName}
            >
              {template.name}
            </DropdownMenuItem>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
